import * as Sentry from '@sentry/browser';

export const LOG_LEVEL_DEBUG = 1;
export const LOG_LEVEL_INFO = 2;
export const LOG_LEVEL_WARN = 4;
export const LOG_LEVEL_ERROR = 8;

let logLevel = LOG_LEVEL_DEBUG;

const doLog = (message) => console.dir(message); // eslint-disable-line no-console

// https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
const replaceErrors = (key, value) => {
  if (value instanceof Error) {
    const error = {};

    Object.getOwnPropertyNames(value).forEach((key) => {
      error[key] = value[key];
    });

    return error;
  }

  return value;
};

const doError = (message) => {
  if (typeof message === 'object') {
    console.error(JSON.stringify(message, replaceErrors)); // eslint-disable-line no-console
    Sentry.captureException(JSON.stringify(message, replaceErrors));
  } else {
    console.error(message); // eslint-disable-line no-console
    Sentry.captureException(message);
  }
};

const logger = {
  debug: (message) => {
    if (logLevel <= LOG_LEVEL_DEBUG) {
      doLog(message);
    }
  },

  info: (message) => {
    if (logLevel <= LOG_LEVEL_INFO) {
      doLog(message);
    }
  },

  warn: (message) => {
    if (logLevel <= LOG_LEVEL_WARN) {
      doLog(message);
    }
  },

  error: (message) => {
    if (logLevel <= LOG_LEVEL_ERROR) {
      doError(message);
    }
  },

  setLevel: (level) => {
    logLevel = level;
  },
};

export default logger;
